import { Checkbox } from "shared/components/bulma/checkbox";

const PartnersCheckbox = ({ onChange, partners }) => {

    const handleChange = (event) => {
        const { name } = event.target;
        const partner = partners.find(partner => partner.label === name);
        partner.picked = !partner.picked;

        onChange && onChange({ target: { value: [...partners] } });
    };

    if (!partners) { return null; }

    return (
        <>
            {partners.map((partner) => {
                return (
                    <Checkbox name={partner.label}
                        id={`partner-${partner.label}`}
                        checked={partner.picked}
                        onChange={handleChange}
                        key={`partner-${partner.label}`}
                    >
                        {partner.label}
                    </Checkbox>
                )
            })
            }
        </>
    )

}

export { PartnersCheckbox };
